import { render, staticRenderFns } from "./StatusRegional.vue?vue&type=template&id=5a1763bb&scoped=true"
import script from "./StatusRegional.vue?vue&type=script&lang=js"
export * from "./StatusRegional.vue?vue&type=script&lang=js"
import style0 from "./StatusRegional.vue?vue&type=style&index=0&id=5a1763bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1763bb",
  null
  
)

export default component.exports